// @module NVT.NuSmart_Sponser_Profile.NusmartSponserProfileModule
define('NVT.NuSmart_Sponser_Profile.NusmartSponserProfileModule.View'
	, [
		'nvt_nusmart_sponser_profile_nusmartsponserprofilemodule.tpl'

		, 'NVT.NuSmart_Sponser_Profile.NusmartSponserProfileModule.SS2Model'

		, 'Backbone'

		, 'NVT.NuSmart_Sponser_Profile.NusmartSponserProfileModule.View'

		, 'ProductDetails.Full.View'
	]
	, function (
		nvt_nusmart_sponser_profile_nusmartsponserprofilemodule_tpl

		, NusmartSponserProfileModuleSS2Model

		, Backbone

		, NusmartSponserProfileModuleView

		, ProductDetailsFullView
	) {
		'use strict';

		// @class NVT.NuSmart_Sponser_Profile.NusmartSponserProfileModule.View @extends Backbone.View
		return Backbone.View.extend({

			template: nvt_nusmart_sponser_profile_nusmartsponserprofilemodule_tpl

			, initialize: function (options) {
				this.options = options;
				this.container = options.container;
				this.layout = this.container.getComponent('Layout');
				this.pdp = this.container.getComponent('PDP');
				var self = this;
				if (self.pdp) {
					self.pdp.on("afterShowContent", function () {
						var itemDetailSpons = self.pdp.getItemInfo();
						var model = new NusmartSponserProfileModuleSS2Model();
						model
							.fetch({
								async: false,
								data: {
									getsku: itemDetailSpons.item.itemid,
										mopimg: SC.CONFIGURATION.MyOrgProfile.config
								},
							})
							.done(function (result) {
								self.listspeakerinformation = result.message
								self.render();
							});
					});
				}
			}
			,	events: {
				'click [data-action="data-action-speaker-information-details"]': 'speakerInformationDetails'
			}
			, bindings: {
			}

			, childViews: {

			}

			,	speakerInformationDetails : function(e){
				var self = this;
				var getcurrentvalue = e.currentTarget.value

				if(getcurrentvalue)
				{
					var getlistselect = self.listspeakerinformation.filter(function(spdata) {
						return spdata.id == getcurrentvalue
					});
					if (this.layout && getlistselect.length > 0) {

						var modalMessage = new NusmartSponserProfileModuleView({ container: this.container,headertitle:getlistselect[0].name +' - '+getlistselect[0].category ,getspeakersinformation: getlistselect[0].profile});
							modalMessage.modalClass ='modal-md';
							modalMessage.title = getlistselect[0].name +' - '+getlistselect[0].category;
							this.options.container.layout.showInModal(modalMessage);
						return false;
					}
				}
			}

			//@method getContext @return NVT.NuSmart_Sponser_Profile.NusmartSponserProfileModule.View.Context
			, getContext: function getContext() {
				//@class NVT.NuSmart_Sponser_Profile.NusmartSponserProfileModule.View.Context
				return {
					image: this.options.image ?  this.options.image : SC.CONFIGURATION.MyOrgProfile.config ,
					listspeakerinformation: this.listspeakerinformation || '',
					headertitle :  this.options.headertitle || '' ,
					getspeakersinformation :  this.options.getspeakersinformation || '' ,

				};
			}
		});
	});
